import { message, Result, Statistic } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalState } from '../../../../store/state';
import { GetCampaignPayoutDetails } from '../../../../apis/Admin/Campaigns/Payouts/GetCampaignPayoutDetails';
import './CampaignPayoutHolder.styles.scss';
import CurrencyIcon from '../../../Common/CurrencyIcon';

const CampaignPayoutHolder = ({ campStatus }) => {
  const params = useParams();
  const [user] = useGlobalState('user');
  const [payout, setPayout] = useState({
    campaignCost: 0,
    totalInfluencers: 0,
    totalReach: 0,
    totalEngagementRate: 0,
  });

  const RetirivePayoutDetails = () => {
    GetCampaignPayoutDetails(user.accessToken, params.campaignId).then(({ status, response }) => {
      if (status === 200) {
        setPayout(response);
      } else {
        message.error('There is some issue while retiving Payout details');
      }
    });
  };

  useEffect(() => {
    // console.log(params.campaignId)
    if (campStatus === 'completed' || campStatus === 'closed') {
      RetirivePayoutDetails();
    }
  }, []);
  return (
    <div className="payout_holder">
      {
        campStatus === 'completed' || campStatus === 'closed' ?
          <div className="payout_holder_sets d-flex justify-content-between align-items-end p-3">
            <div className="payout_holder_sets_each">
              <h2>{CurrencyIcon()}<Statistic value={payout.campaignCost || 0}
                className="custom_number_format"/></h2>
              <h5>Campaign Cost</h5>
            </div>
            <div className="payout_holder_sets_each">
              <h2>{payout.totalInfluencers || 0}</h2>
              <h5>Total Influencers</h5>
            </div>
            <div className="payout_holder_sets_each">
              <h2>{payout.totalReach || 0}</h2>
              <h5>Total Reach</h5>
            </div>
            <div className="payout_holder_sets_each">
              <h2>{payout.totalEngagementRate || 0}</h2>
              <h5>Total Engagement Rate</h5>
            </div>
          </div>:
          <Result title={<>Payout data only available in<br/><strong>Completed Campaigns</strong></>}/>
      }
    </div>
  );
};

export default CampaignPayoutHolder;
